import React from 'react';
import PropTypes from 'prop-types';
import Styled from 'styled-components';
import Theme from '../common/NekoTheme';

/**
 * @param {string} id
 * @param {string} name
 * @param {string} value
 * @param {string} description
 * @param {string} placeholder
 */
const StyledNekoInput = Styled(props => {
  const { id, name, value = '', description, placeholder = '', readOnly = false, type = 'text', step = 1, min = 1, max = 999, maxLength = 3, className, ...rest } = props;

  const onChange = (e) => {
    if (props.onChange) props.onChange(e.target.value);
  };

  const onBlur = (e) => {

    if (props.onBlur && value !== e.target.value) {
      props.onBlur(e.target.value);
    }
  };

  return (
    <div className={[className].join(' ')}>
      {type === 'number'
        ? <input className="neko-input" {...rest} id={id} name={name} defaultValue={value} type={type} step={step} min={min} max={max} maxlength={maxLength} placeholder={placeholder} onChange={onChange} onBlur={onBlur} readOnly={readOnly} />
        : <input className="neko-input" {...rest} id={id} name={name} defaultValue={value} type={type} 
        spellcheck="false"
        placeholder={placeholder} onChange={onChange} onBlur={onBlur} readOnly={readOnly} />
      }
      {description && <p className="neko-input-description">{description}</p>}
    </div>
  );
})`
  .neko-input {
    font-family: ${Theme.fontFamily};
    font-size: ${Theme.fontSizeText};
    border: 2px solid ${Theme.blue};
    box-sizing: border-box;
    height: 30px;
    background: #e8ecff;
    padding: 0 10px;

    &::placeholder {
      color: rgba(0, 0, 0, 0.25);
    }

    :focus {
      background-color: white;
    }

    :read-only {
      background-color: ${Theme.gray};
    }
  }

  .neko-input-description {
    font-family: ${Theme.fontFamily};
    font-size: ${Theme.fontSizeSmall};
    line-height: 14px;
    margin-top: 8px;
    margin-bottom: 0;
  }
`;

const NekoInput = (props) => {
  return (<StyledNekoInput {...props} />);
};

NekoInput.propTypes = {
  id: PropTypes.string,
  type: PropTypes.oneOf(['number', 'text']),
  name: PropTypes.string,
  value: PropTypes.string,
  description: PropTypes.string,
  placeholder: PropTypes.string,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  readOnly: PropTypes.bool,
  step: PropTypes.number,
  min: PropTypes.number,
  max: PropTypes.number,
  maxLength: PropTypes.number,
};

NekoInput.defaultProps = {
  id: undefined,
  type: 'text',
  name: undefined,
  value: '',
  description: undefined,
  placeholder: '',
  onChange: undefined,
  onBlur: undefined,
  readOnly: false,
  step: 1,
  min: 1,
  max: 999,
  maxLength: 3
};

export { NekoInput };
